<template>
  <section class="video-cards-wrapper" aria-label="Our Services">
    <h1 class="hero-title">Our Services</h1>

    <div class="video-cards-grid">
      <article
          v-for="(video_item, index) in videoCards"
          :key="index"
          class="video-card"
          @mousemove="handleMouseMove"
          tabindex="0"
          :aria-label="`${video_item.title} video card`"
      >
          <video
              v-if="isVideo(video_item.src)"
              class="media-element"
              :src="video_item.src"
              autoplay
              muted
              loop
              playsinline
              preload="metadata"
              aria-hidden="true"
          ></video>

          <v-img
              v-else
              class="media-element"
              :src="video_item.src"
              alt=""
          ></v-img>

          <div class="media-overlay">
            <h3>{{ video_item.title }}</h3>
            <p>{{ video_item.description }}</p>
          </div>

      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "Services",
  methods: {
    isVideo(src) {
      const videoExtensions = ["mp4", "webm", "ogg"];
      const extension = src.split(".").pop().toLowerCase();
      return videoExtensions.includes(extension);
    },
    handleMouseMove(e) {
      const card = e.currentTarget;
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      card.style.setProperty("--mouse-x", `${x}px`);
      card.style.setProperty("--mouse-y", `${y}px`);
    }
  },
  data: () => ({
    videoCards: [
      {
        title: "3D scanning booths",
        description: "We offer advanced 3D scanning booths with powerful software to create photorealistic 3D assets of people, objects, and more",
        src: require("../../assets/photos/cabin.png"),
      },
      {
        title: "Auto Rigging",
        description: "Save days of manual work—we rig your characters in minutes with speed and precision",
        src: require("../../assets/photos/rigging.png")
      },
      {
        title: "Game Ready Animations",
        description: "Fully optimized, rigged characters ready to drop straight into your game engine",
        src: require("../../assets/videos/dancing.mp4")
      },
      {
        title: "Cutting-edge motion capture system",
        description: "We capture real human movement to create tailor-made animations—authentic, dynamic, and perfectly aligned with your vision",
        src: require("../../assets/photos/motion_capture.png")
      },
      {
        title: "Lip Sync & Voice Cloning",
        description: "Bring characters to life with frame-accurate lip sync and stunningly accurate voice cloning. Perfect for expressive, production-ready animations and custom voiceovers",
        src: require("../../assets/photos/voice-cloning.png")
      },
      {
        title: "Accurate Anthropometrics",
        description: "We create digital avatars with scientifically precise body measurements, perfectly suited for tailoring, healthcare, and any field where accuracy matters",
        src: require("../../assets/photos/measures.png")
      }
    ]
  })
};
</script>

<style scoped lang="scss">
.hero-title {
  font-size: clamp(1.8rem, 5vw, 4rem);
  margin: 3% 0 1% 0;
  font-weight: bold;
  text-align: center;
  background: linear-gradient(180deg, #f8f8ff, rgba(248, 248, 255, 0.5));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  user-select: none;
}

.video-cards-wrapper {
  //min-height: 100vh;
  box-sizing: border-box;
  //padding: 0 1rem 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.video-cards-grid {
  display: grid;
  grid-template-columns: 1fr; // Default: 1 column on mobile
  gap: 24px;
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
}

.video-card {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  background-color: rgba(168, 168, 168, 0.15);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  //width: 100vw;
  //height: 450px;

  &:focus {
    outline: 3px solid #6c63ff;
    outline-offset: 3px;
  }
}

.video-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  pointer-events: none;
  background: radial-gradient(
          800px circle at var(--mouse-x, 50%) var(--mouse-y, 50%),
          rgba(255, 255, 255, 0.06),
          transparent 40%
  );
  opacity: 0;
  transition: opacity 0.5s;
  z-index: 2;
}

.video-card:hover,
.video-card:focus {
  transform: scale(1.03);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3);
}

.video-card:hover::before,
.video-card:focus::before {
  opacity: 1;
}

//.media-container {
  //width: 100%;
  //flex: 2;
  //overflow: hidden;
  //border-top-left-radius: 12px;
  //border-top-right-radius: 12px;
  //background-color: #000;
  //background: rgba(0, 0, 0, 0.45);
  //backdrop-filter: blur(8px);
  //color: #f8f8f8;
//}

.media-element {
  //width: 100%;
  aspect-ratio: 16 / 9;
  //object-fit: cover; /* makes sure video/image covers the container nicely */
  //display: block; /* avoid inline element spacing issues */
}


.media-overlay {
  padding: 1.5rem;
  //background: rgba(0, 0, 0, 0.45);
  //backdrop-filter: blur(8px);
  //color: #f8f8f8;
  //z-index: 3;
  //border-bottom-left-radius: 12px;
  //border-bottom-right-radius: 12px;
  //user-select: text;
  //box-sizing: border-box;
  //width: 100%;
  //flex: 1;
  //display: flex;
  //flex-direction: column;
  //justify-content: center;
}

.media-overlay h3 {
  margin: 0 0 0.5rem;
  font-size: 1.5rem;
  color: #ffffff;
  font-weight: 700;
}

.media-overlay p {
  margin: 0;
  color: #ccc;
  font-size: 1.05rem;
  line-height: 1.4;
}

/* Responsive Adjustments */
@media (max-width: 600px) {
  //.hero-title {
  //  font-size: clamp(1.6rem, 6vw, 2.5rem);
  //  margin-bottom: 1.5rem;
  //}

  .media-overlay h3 {
    font-size: 1.1rem;
  }

  .media-overlay p {
    font-size: 0.9rem;
  }
}

@media (max-width: 1024px) {
  .media-overlay h3 {
    font-size: 1.3rem;
  }

  .media-overlay p {
    font-size: 1rem;
  }
}

@media (min-width: 768px) {
  .video-cards-grid {
    grid-template-columns: repeat(2, 1fr); // Tablet: 2 columns
  }
}

@media (min-width: 1024px) {
  .video-cards-grid {
    grid-template-columns: repeat(3, 1fr); // Desktop: 3 columns
  }
}
</style>
